import { AddLegalEntities } from './AddLegalEntities.main';

export { AddLegalEntities };
